import NavBar from './navbar';

export default class NavBarDesktop extends NavBar {
}
